import React, { useEffect, useState } from "react";
import styles from "./Qrcode.module.scss";
import QRCode from "react-qr-code";
import { useDispatch } from "react-redux";
import Button from "../button/Button";
import {
  TrackOrderStatusAction,
  payOrderAction,
} from "../../redux/actions/orderStatus/orderStatusAction";
import PendingPaymentCard from "../PendingPaymentCard/PendingPaymentCard";

type QRLinkProps = {
  reference: string;
};

const QrCode = ({ reference }: QRLinkProps) => {
  const dispatch = useDispatch();
  const [qrcodeimg, setQrcodeimage] = useState("");
  const [componentData, setComponentData] = React.useState<any>({
    pendingfor5min: false,
  });
  const payload = {
    reference: reference,
    paymentOption: "NQR",
  };

  const updatePendingStatus = () => {
    setComponentData({
      ...componentData,
      pendingfor5min: true,
    });
  };
  useEffect(() => {
    payOrderAction(payload,'default', dispatch, (data: any) => {
      setQrcodeimage(data?.data?.payment_detail?.redirect_url);
    });
  }, []);

  return (
    <>
      {componentData?.pendingfor5min ? (
        <PendingPaymentCard paymentmethod="Transfer" />
      ) : (
        <div className={styles.container}>
          <div className={styles.scan}>
            Scan the QR code below with your mobile
            <br /> banking app to complete payment
          </div>
          {qrcodeimg && (
            <div className={styles.qrCode}>
              <img src={qrcodeimg} alt="qrcode image" />
              {/* <QRCode
          value="https://www.figma.com/file/k89ji2LuuBFUp2cuyqP8ec/Checkout?node-id=54%3A2"
          size={150}
        /> */}
              <div>
                <Button
                  width="100%"
                  onClick={() =>
                    TrackOrderStatusAction(
                      payload,
                      'default',
                      dispatch,
                      updatePendingStatus
                    )
                  }
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#8E173E",
                  }}
                  value="I’ve sent the money"
                />
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default QrCode;
